import authService from './authService';
import { ensureOk, readData, toQuery } from './apiResponse';
import type { BudgetReport, CategoryBudgetInput } from '../types/finance';

/**
 * Finanças → Orçamento por categoria (Fase 5): orçamento mensal em categorias de despesa —
 * `competence = 0` é o padrão mensal, AAAAMM é a exceção daquele mês — e o relatório do mês.
 */
class BudgetService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /reports/budget?year=&month= — uma linha por categoria de despesa ativa (raízes e filhas). */
  async getReport(year: number, month: number): Promise<BudgetReport> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/reports/budget${toQuery({ year, month })}`);
    const r = await readData<BudgetReport>(response, 'Falha ao carregar o orçamento');
    return { ...r, items: r?.items ?? [] };
  }

  /** PUT /categories/:id/budget { competence (0 ou AAAAMM), amount_cents > 0 } — upsert; categoria precisa ser de despesa (400). */
  async set(categoryId: number, input: CategoryBudgetInput): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.put(`/categories/${categoryId}/budget`, input);
    await ensureOk(response, 'Falha ao salvar o orçamento');
  }

  /** DELETE /categories/:id/budget?competence= — remove o padrão (0) ou a exceção do mês. */
  async remove(categoryId: number, competence: number): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.delete(`/categories/${categoryId}/budget?competence=${competence}`);
    await ensureOk(response, 'Falha ao remover o orçamento');
  }
}

export const budgetService = new BudgetService();
export default budgetService;
